import { render, staticRenderFns } from "./BookingAnalytics.vue?vue&type=template&id=1d95013b&scoped=true"
import script from "./BookingAnalytics.vue?vue&type=script&lang=js"
export * from "./BookingAnalytics.vue?vue&type=script&lang=js"
import style0 from "./BookingAnalytics.vue?vue&type=style&index=0&id=1d95013b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d95013b",
  null
  
)

export default component.exports